import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/main.scss";
import Home from "./pages/home";
import ReactGA from "react-ga4";
import {
  BrowserRouter,
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import TermsCondition from "./pages/termsCondition";
import PrivacyPolicy from "./pages/privacyPolicy";
import Library from "./pages/library/library";
import ResumeDetails from "./pages/resumeDetails/resumeDetails";
import Login from "./pages/authentication/login";
import toast, { Toaster } from "react-hot-toast";
import Signup from "./pages/authentication/signup";
import Forgot from "./pages/authentication/forgot";
// Initialize GA4 with your measurement ID
ReactGA.initialize("G-5N0YYG0223");

function App() {
  return (
    // <div>
    //   <Home />
    // </div>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms-and-conditions" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/library" element={<Library />} />
        <Route path="/resume-details/:slug/:id" element={<ResumeDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot" Component={Forgot} />
        {/* Redirect unknown routes */}
      </Routes>
    </Router>
  );
}

export default App;
